import { useState, useEffect } from "react";

export const useMobileDetect = (check = 768) => {
  const [width, setWidth] = useState(window.innerWidth);
  //const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= check;

  return { isMobile };
};
